"use client";

export interface KinsaEmptyStateProps {
  onStartVisit?: () => void;
  isProcessing?: boolean;
  variant?: "first-time" | "returning";
}

export default function KinsaEmptyState({
  onStartVisit,
  isProcessing = false,
}: KinsaEmptyStateProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <h2 className="mb-1 font-heading font-medium text-2xl leading-8 tracking-[0.1px] text-text">
        How can we help you today?
      </h2>
      <p className="mb-6 max-w-sm font-sans text-[15px] leading-[22px] tracking-[0.25px] text-text-muted">
        Our board-certified doctors are available 24/7,
        <br />
        for issues big or small.
      </p>
      <button
        onClick={onStartVisit}
        disabled={isProcessing}
        className="w-full h-[44px] rounded-[99px] bg-primary font-sans font-medium text-[15px] leading-[22px] tracking-[1.5px] uppercase text-on-primary disabled:opacity-50 transition-opacity"
      >
        {isProcessing ? (
          <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full mx-auto" />
        ) : (
          "get care now"
        )}
      </button>
    </div>
  );
}
